import { render, staticRenderFns } from "./NodeDetail.vue?vue&type=template&id=47f1c27a&scoped=true&"
import script from "./NodeDetail.vue?vue&type=script&lang=ts&"
export * from "./NodeDetail.vue?vue&type=script&lang=ts&"
import style0 from "./NodeDetail.vue?vue&type=style&index=0&id=47f1c27a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f1c27a",
  null
  
)

export default component.exports